<template>
  <div>
    <ResumenVacaciones class="mt-2" :id="$route.params.id" />
  </div>
</template>

<script>
import ResumenVacaciones from "@/views/rrhh/views/payroll/components/vacaciones/components/ResumenVacaciones.vue";

export default {
  components: {
    ResumenVacaciones,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>